<script lang="ts">
import { computed, defineComponent } from "vue";
import formatUtils from "@/businesslogic/utils/formatUtils";
import dataUtils from "@/businesslogic/utils/dataUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Zahlweise",
  components: {},
  props: {
    zahlweiseText: String,
    zahlweiseFeldWert: Number,
    zahlweiseBeitrag: Number,
    zahlweiseMindestbeitrag: {
      type: Number,
      default: 25,
    },
  },
  setup(props) {
    const piniaStore = useFormStore();
    const { formatCurrency } = formatUtils();
    const { gte } = dataUtils();

    const feldId = computed(() => {
      return "zahlungsweise" + props.zahlweiseFeldWert;
    });

    return {
      props,
      piniaStore,
      formatCurrency,
      feldId,
      gte,
    };
  },
});
</script>

<template>
  <div
    class="o-grid__cell o-grid__cell--11 o-grid__cell--4-480"
    v-if="gte(props.zahlweiseBeitrag, props.zahlweiseMindestbeitrag)"
  >
    <input
      v-model.number="piniaStore.state.tarifinformationen.zahlungsweise"
      :value="props.zahlweiseFeldWert"
      :id="feldId"
      name="tariffPaymentFrequency"
      class="c-form-control-radio__input"
      type="radio"
      data-parsley-multiple="tariffPaymentFrequency"
      :data-cy="feldId"
    />
    <label :for="feldId" class="c-form-control-radio__label">
      <span aria-hidden="true" class="c-form-control-radio__icon"></span>
      <span class="c-form-control-radio__label-text">
        {{ props.zahlweiseText + "&nbsp;" + formatCurrency(props.zahlweiseBeitrag) }}
      </span>
    </label>
  </div>
</template>

<style scoped></style>
